import React from "react";
import { t } from "../../../utils/i18n";

const DAYS_AHEAD = 14;

const toISODate = (d: Date) => {
  const y = d.getFullYear(), m = String(d.getMonth() + 1).padStart(2, "0"), day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

export default function WhenStep({
  lang, date, time, priceNote, onDateChange, onTimeChange, onPriceNoteChange,
}: {
  lang: string; date: string | null; time: string | null; priceNote: string;
  onDateChange: (d: string) => void; onTimeChange: (t: string) => void; onPriceNoteChange: (v: string) => void;
}) {
  const days = React.useMemo(() => {
    const out: { iso: string; weekday: string; num: string }[] = [];
    const fmt = new Intl.DateTimeFormat(lang, { weekday: "short" });
    for (let i = 0; i < DAYS_AHEAD; i++) {
      const d = new Date();
      d.setDate(d.getDate() + i);
      out.push({ iso: toISODate(d), weekday: fmt.format(d), num: String(d.getDate()) });
    }
    return out;
  }, [lang]);

  return (
    <div>
      <div style={{ fontSize: 17, fontWeight: 800, marginBottom: 4 }}>{t(lang, "date_step_when_title")}</div>
      <div style={{ fontSize: 12.5, color: "#999", marginBottom: 16 }}>{t(lang, "date_step_when_sub")}</div>

      <div style={{ display: "flex", gap: 8, overflowX: "auto", paddingBottom: 6, marginBottom: 20 }}>
        {days.map(d => (
          <button
            key={d.iso}
            onClick={() => onDateChange(d.iso)}
            style={{
              flexShrink: 0, width: 52, padding: "10px 0", borderRadius: 12, cursor: "pointer",
              border: date === d.iso ? "1.5px solid #0a0a0a" : "1px solid #eee",
              backgroundColor: date === d.iso ? "#0a0a0a" : "white",
              color: date === d.iso ? "white" : "#333",
            }}
          >
            <div style={{ fontSize: 10.5, textTransform: "uppercase", fontWeight: 600, opacity: 0.7 }}>{d.weekday}</div>
            <div style={{ fontSize: 15, fontWeight: 700, marginTop: 2 }}>{d.num}</div>
          </button>
        ))}
      </div>

      {/* Un seul contrôle natif pour l'heure — remplace l'ancienne grille de 32 boutons de
          créneaux + bouton "Autre heure" séparé, dénoncée par le fondateur comme "pas cohérent,
          pas beau" : le sélecteur natif du navigateur (curseur/molette selon l'OS) suffit. */}
      <label style={{ fontSize: 12, fontWeight: 600, color: "#666", display: "block", marginBottom: 8 }}>{t(lang, "date_step_when_time_label")}</label>
      <input
        type="time"
        value={time || ""}
        onChange={e => onTimeChange(e.target.value)}
        style={{ width: "100%", padding: "14px 16px", borderRadius: 14, border: "1px solid #eee", backgroundColor: "#F8F8F8", fontSize: 16, fontWeight: 700, color: "#0a0a0a", outline: "none", marginBottom: 16, boxSizing: "border-box" }}
      />

      {/* Champ Prix masqué sur demande du fondateur : aucun règlement en ligne pour l'instant, le
          paiement se fait sur place — reviendra quand le paiement en ligne du Connection sera
          construit. priceNote/onPriceNoteChange restent dans les props (juste jamais renseignés
          tant que ce bloc est masqué) pour réactiver ça d'un simple décommentage le moment venu.
      <label style={{ fontSize: 12, fontWeight: 600, color: "#666", display: "block", marginBottom: 6 }}>{t(lang, "date_price_label")}</label>
      <input
        value={priceNote}
        onChange={e => onPriceNoteChange(e.target.value)}
        placeholder={t(lang, "date_price_placeholder")}
        style={{ width: "100%", padding: "11px 12px", borderRadius: 10, border: "1px solid #E0E0E0", fontSize: 14, outline: "none", boxSizing: "border-box", marginBottom: 6 }}
      />
      <div style={{ fontSize: 11.5, color: "#999" }}>{t(lang, "date_price_hint")}</div>
      */}
    </div>
  );
}
